export interface CreateDebitCardInfo {
  token: string
  owner: {
    first_name: string
    last_name: string
    address: {
      address_1: string
      city: string
      state: string
      postal_code: string
    }
  }
}

export interface CreateExternalDebitCardInfo {
  token: string
  owner: {
    name: {
      first: string
      last: string
    }
    address: {
      line1: string
      city: string
      state: string
      zipcode: string
    }
  }
}

export interface CreateDebitCardResponse {
  id: number
  network: string
  last_four: number
  expiration: string
  time_created: string
}

export interface ConnectedCard
  extends Omit<CreateDebitCardResponse, 'last_four'> {
  last4: string
}

export const DebitCardType = ['PAYOUT_CARD', 'EWA_CARD'] as const

export type DebitCardType = (typeof DebitCardType)[number]

export const CardType = [
  'DISBURSEMENT_CARD',
  'DISBURSEMENT_BANK_INSTANT',
  'DISBURSEMENT_BANK_DELAYED',
  'WALLET_EXTERNAL_TRANSFER_CARD',
  'WALLET_EXTERNAL_TRANSFER_BANK_INSTANT',
  'WALLET_EXTERNAL_TRANSFER_BANK_DELAYED',
  'EWA_CARD',
  'EWA_BANK_INSTANT',
  'EWA_BANK_DELAYED',
] as const

export type CardType = (typeof CardType)[number]

export interface ExternalCardParams {
  type: CardType
}

export enum VerifyCardErrorReasonCode {
  UNSUPPORTED_CARD_TYPE = 'UNSUPPORTED_CARD_TYPE',
  NOT_DEBIT_CARD = 'NOT_DEBIT_CARD',
  INVALID_CARD_DETAILS = 'INVALID_CARD_DETAILS',
}

export interface ConnectedCardSelection extends ConnectedCard {
  type: DebitCardType
}
